import React, {useState} from 'react'
import {useQuery} from "react-query"
import moment from 'moment'
import nprogress from 'nprogress'
import {toast} from "react-toastify"
import useAuth from "auth/useAuth"
import Spinner from "components/Spinner"
import Rescuer from "components/Rescuer"
import {formatFileSize} from "utils/utils"
import {capitalizeFirstLetter} from "utils/text_utils"
import './PendingUploads.css'


export default function Pending(props) {

    const {auth, API, admin} = useAuth()
    const {data: uploads, isLoading, refetch} = useQuery(["pending-uploads"], () => auth(API.uploadsPendingGet).then(response => response.data))
    const [comments, setComments] = useState({})

    if (!admin || !uploads?.length) return <></>

    const handleCommentChange = (uploadId, value) => {
        setComments(prev => ({...prev, [uploadId]: value}))
    }

    const approve = (upload) => {
        nprogress.start()
        const comment = comments[upload.id] || ''
        auth(API.uploadsIdApprovePut, {id: upload.id}, {comment}).then(response => {
            refetch()
            toast.success("Prihvaćeno")
            setComments(prev => {
                const newComments = {...prev}
                delete newComments[upload.id]
                return newComments
            })
            nprogress.done()
        }).catch(response => {
            toast.error(response.data)
            nprogress.done()
        })
    }

    const reject = (upload) => {
        const comment = comments[upload.id] || ''
        if (!comment.trim()) {
            toast.error("Mora komentar zašto kada se odbija")
            return
        }
        nprogress.start()
        auth(API.uploadsIdRejectPut, {id: upload.id}, {comment}).then(response => {
            refetch()
            toast.success("Odbijeno")
            setComments(prev => {
                const newComments = {...prev}
                delete newComments[upload.id]
                return newComments
            })
            nprogress.done()
        }).catch(response => {
            toast.error(response.data)
            nprogress.done()
        })
    }
    
    
    const isOtherType = (upload) => {
        return !(upload['content-type'].startsWith('image/') || upload['content-type'].includes('pdf'))
    }
    
    
    return <section className="container-fluid shadow white" id="pending-uploads">
        <h3>Profilne slike za odobravanje</h3>

        {isLoading && <Spinner/>}
        {!uploads?.length && !isLoading && <p>No pending uploads</p>}

        <div className="uploads-container">
            {uploads?.map(upload => <div key={upload.id} className="pending-upload">
                {upload['content-type'].startsWith('image/') && <div className="preview-container" onClick={() => window.open(upload.url, '_blank')}>
                    <img src={upload.url} className="preview" alt={upload.filename}/>
                </div>}
                {upload['content-type'].includes('pdf') && <div className="preview-container" onClick={() => window.open(upload.url, '_blank')} title={upload.filename}>
                    <i className="fa-regular fa-file-pdf preview"/>
                </div>}
                {isOtherType(upload) && <div className="preview-container" onClick={() => window.open(upload.url, '_blank')} title={upload.filename}>
                    <i className="fa-regular fa-file preview"/>
                </div>}
                <div className="vertical">
                    <div>{capitalizeFirstLetter(moment(upload.created).calendar())}</div>
                    <Rescuer rescuer={upload.user} onClick="profile"/>
                    <div>{upload.filename}</div>
                    <div>{formatFileSize(upload.size)}</div>
                    <textarea placeholder="Razlog zašto..." value={comments[upload.id] || ''} onChange={e => handleCommentChange(upload.id, e.target.value)} rows={2}/>
                    <div className="buttons">
                        <button className="btn btn-light btn-sm" onClick={e => approve(upload)}><i className="fa-solid fa-check"/>&nbsp;&nbsp;Može</button>
                        <button className="btn btn-light btn-sm" onClick={e => reject(upload)}><i className="fa-solid fa-ban"/>&nbsp;&nbsp;Ne može</button>
                    </div>
                </div>
            </div>)}
        </div>
    </section>
}